import { render } from "./HorsePerformanceModal.vue?vue&type=template&id=fc74973c&scoped=true"
import script from "./HorsePerformanceModal.vue?vue&type=script&lang=js"
export * from "./HorsePerformanceModal.vue?vue&type=script&lang=js"

import "./HorsePerformanceModal.vue?vue&type=style&index=0&id=fc74973c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc74973c"]])

export default __exports__